import { NotificationCard } from './NotificationCard';
import { useNotification } from '../../hooks/notification/useNotification';
import { Comment } from 'react-loader-spinner';
import { useUnreadNotification } from '../../hooks/notification/useUnreadNotification';
import { Notification } from '../../types/notification';

export default function NotificationView() {

  const { data: unreadNotifications } = useUnreadNotification();
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useNotification({ limit: 25 });

  const notifications = data?.pages.flatMap((page) => page.items) ?? [];

  const read = notifications?.filter((n: Notification) => n.is_read) || [];

  return (
    <div className="max-w-2xl mx-auto animate-in fade-in duration-300">
      {/* Header */}
      <div className="flex items-center justify-between mb-4 px-2">
        <h3 className="text-xl font-bold text-slate-800">
          Recent Notifications
        </h3>

        {unreadNotifications?.length > 0 && (
          <span className="text-xs font-bold text-emerald-600 bg-emerald-50 px-3 py-1 rounded-full">
            {unreadNotifications?.length} Unread
          </span>
        )}
      </div>

      {/* Loading */}
      {isLoading && (
        <div className="flex items-center justify-center py-16">
          <Comment
            visible
            height="80"
            width="80"
            ariaLabel="notification-loading"
            color="#fff"
            backgroundColor="#1abd69"
          />
        </div>
      )}

      {/* Empty */}
      {!isLoading && notifications?.length === 0 && (
        <div className="p-12 text-center bg-white rounded-3xl border border-dashed border-slate-200">
          <div className="text-3xl mb-3">🎉</div>
          <p className="text-slate-500 font-semibold">You're all caught up!</p>
        </div>
      )}

      {/* Unread Section */}
      {unreadNotifications?.length > 0 && (
        <div className="space-y-3 mb-6">
          <p className="text-xs font-bold text-emerald-600 px-2 uppercase tracking-wider">
            Unread
          </p>

          {Array.isArray(unreadNotifications) &&
            unreadNotifications?.map((note: Notification) => (
              <NotificationCard key={note.notification_id} note={note} />
            ))}
        </div>
      )}

      {/* Read Section */}
      {read.length > 0 && (
        <>
          <div className="space-y-3">
            <p className="text-xs font-bold text-slate-400 px-2 uppercase tracking-wider">
              Read
            </p>

            {read.map((note: Notification) => (
              <NotificationCard key={note.notification_id} note={note} />
            ))}
          </div>

          <div className="flex items-center justify-center mt-6">
            <button
              onClick={() => fetchNextPage()}
              disabled={!hasNextPage || isFetchingNextPage}
              className="px-4 py-2 bg-slate-100 text-slate-600 rounded-md hover:bg-slate-200 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isFetchingNextPage
                ? "Loading..."
                : hasNextPage
                  ? "Load more"
                  : "No more"}
            </button>
          </div>
        </>
      )}
    </div>
  );
}


